
import { EXCLUSIVE_URL } from "constants/accesos";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { generalActions } from "redux/generalSlice";
import { getBasePath } from "utils";

/**
 * Hook para los permisos de la vista, utilizado en el ProtectedRoutes para guardar los permisos de la vista activa en Redux.
 * 
 * @hook
 * 
*/

const usePermisos = (elemento, data) => {
  const dispatch = useDispatch();
  const usuario = useSelector(state => state.general.usuario);
  const param = useParams();

  const basePath = useMemo(() => (
    elemento === "view" ? getBasePath(data, param) : null
  ), [elemento, data, param]);

  const accionesDefault = {
    alta: false,
    baja: false,
    modificacion: false,
    denegado: true,
    consulta: false,
    total: false,
  };

  const accionesFull = {
    alta: true,
    baja: true,
    modificacion: true,
    denegado: false,
    consulta: true,
    total: true,
  };

  const acciones = useMemo(() => {
    if (!usuario) return accionesDefault;
    if (EXCLUSIVE_URL.includes(basePath)) return accionesFull;
    if (usuario.super) return accionesFull;
    
    const accionesPermitidas = usuario.accesos?.flatMap(acceso => acceso) || [];

    const permiso = accionesPermitidas.find(accion => {
      switch (elemento) {
        case "view":
          return accion?.acceso?.acceso === basePath && accion?.consulta;
        case "tab":
          return accion?.accesos_id === data && accion?.consulta;
        case "button":
          return accion?.accesos_id === data && accion?.total;
        default:
          return false;
      }
    });

    return permiso ? {
      alta: permiso.alta || false,
      baja: permiso.baja || false,
      modificacion: permiso.modificacion || false,
      denegado: permiso.denegado || false,
      consulta: permiso.consulta || false,
      total: permiso.total || false,
    } : accionesDefault;
  }, [usuario, basePath, elemento, data]);

  useEffect(() => {
    dispatch(generalActions.setActionsOnView(acciones));
  }, [acciones, dispatch]);

  return acciones;
};

export default usePermisos;
